var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReanalyse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.09497L5.60843 11.8991L9.3916 10.2996M5.83008 11.805C5.92702 7.9839 9.06148 4.91406 12.9149 4.91406C16.8249 4.91406 19.9998 8.08892 19.9998 11.9989C19.9998 15.917 16.8249 19.0838 12.9149 19.0838C10.4914 19.0838 8.35865 17.872 7.07417 16.022",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReanalyse);
export default __webpack_public_path__ + "static/media/Reanalyse.003be3292e773b1df4f74728c7de1144.svg";
export { ForwardRef as ReactComponent };